import React from 'react';
import styles from "./Button.module.scss";
import { motion } from 'framer-motion';
import { LoaderIcon } from 'react-hot-toast';

const Button = ({ onClick, type, loading, variant, disabled, fluid, className, children, text, ...rest }) => {
    return (
        <>
            <motion.button
                {...rest}
                onClick={onClick}
                type={type || "button"}
                disabled={disabled}
                className={` ${className || ""} ${fluid ? "w-100" : ""} ${styles.button}`}
                data-variant={variant}
            >
                {
                    loading ?
                        <LoaderIcon className={styles.loader} />
                        :
                        children || text
                }
            </motion.button>
        </>
    )
}

export default Button;